import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { InfoboxProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardInfobox = dynamic(() => import("./DashboardInfoboxSsr").then((mod) => mod.DashboardInfoboxSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardInfobox = forwardRef<HTMLDivElement, InfoboxProps>((props, ref) => (
  <DynamicDashboardInfobox {...props} forwardedRef={ref} />
));

DashboardInfobox.displayName = "DashboardInfobox";
